<template>
    <div class="language-button">
        <select id="lang-select" @click="getId">
            <option value="bg">
                Bg
            </option>
            <option value="en">
                En
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'LanguageButton',
    data() {
        return {
            select: null,
        }
    },
    methods: {
        getId() {
            this.select = document.getElementById('lang-select')

            this.select.addEventListener('change', () => {
                this.$emit('clicked', this.select.value)
            })
        },
    },
}
</script>

<style lang="scss">
.language-button {
    width: 53px;
    margin-left: 18px;
    border-radius: 10px;

    select {
        padding: 6px;
        border: none;
        color: white;
        background-color: transparent;
        cursor: pointer;

        &:focus {
            outline-color: transparent;
        }

        option {
            margin-bottom: 12px;
            color: black;
            background-color: white;
        }
    }
}
</style>
